var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input-number',{attrs:{"min":_vm.min,"max":_vm.max,"step":_vm.step},on:{"change":_vm.handleChange},model:{value:(_vm.childValue),callback:function ($$v) {_vm.childValue=$$v},expression:"childValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }